// removed by extract-text-webpack-plugin
module.exports = {"curtain":"bmbo_curtain_224b5","curtain-sample":"bmbo_curtain-sample_1NrMY"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Components/CurtainPage.scss
// module id = 28
// module chunks = 0